export const resultsString = ({ total, page, perPage }: Props): string => {
	const initialResult = page * perPage - (perPage - 1);
	const lastResult = page * perPage;
	if (!total) {
		return 'No results';
	} else if (total < lastResult) {
		// TODO: this is not the copy in the designs for MetPubs, it's just "10 of 1,400""
		return `Showing ${initialResult}–${total} results of ${total.toLocaleString()}`;
	} else {
		return `Showing ${initialResult}–${lastResult} results of ${total.toLocaleString()}`;
	}
};

interface Props {
	total: number;
	page: number;
	perPage: number;
}
